<template>
    <div>
        <div class="profile-style">
            <h5 class="mb-4">Person in Event</h5>
            <div class="tabel-action tb-al mb-4">
                <button type="button" v-b-modal.modal-Persons class="btn bg-white bdr-15 btn-block btn-lg"><i class="uil uil-plus mr-2"></i>Add Person</button>
            </div>
            
            <draggable
                v-bind="dragOptions" 
                v-model="personsGroup" 
                handle=".handle"
                @start="drag = true"
                @end="drag = false"
                >

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div v-for="data in personsGroup" :key="data.id" class="link mb-3">
                        <div class="link-drag handle align-items-center d-flex">
                            <i class="uil uil-draggabledots"></i>
                        </div>
                        <div class="link-body">
                            <div class="link-content">
                                <div class="link-icon">
                                    <div class="no-img" v-if="!data.photo"><span class="w-100">NO IMAGE</span></div>
                                    <img v-if="data.photo" class="cn" :src="data.photo">
                                </div>
                                <div class="link-item pr-5">
                                    <div><strong>{{data.name}}</strong></div>
                                    <table>
                                        <tr v-if="data.father">
                                            <td>Father Name</td>
                                            <td class="pl-2 pr-2">:</td>
                                            <td>{{data.father}}</td>
                                        </tr>
                                        <tr v-if="data.mother">
                                            <td>Mother Name</td>
                                            <td class="pl-2 pr-2">:</td>
                                            <td>{{data.mother}}</td>
                                        </tr>
                                        <tr v-if="data.type">
                                            <td>Status</td>
                                            <td class="pl-2 pr-2">:</td>
                                            <td>{{data.type}}</td>
                                        </tr>
                                        <tr v-if="data.address">
                                            <td>Address</td>
                                            <td class="pl-2 pr-2">:</td>
                                            <td>{{data.address}}</td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="link-switch">
                                    <a href="#" v-b-modal.modal-Persons v-on:click.prevent="ASSIGN_FORM_PERSON(data)" class="act">
                                        <i class="uil uil-pen"></i>
                                        <span class="link-tx"> Edit</span>
                                    </a>
                                    <a href="#" v-on:click.prevent="alertDelete(data.id)" class="act">
                                        <i class="uil uil-trash-alt"></i>
                                        <span class="link-tx"> Delete</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </transition-group>

            </draggable>
        </div>

        <b-modal id="modal-Persons" centered hide-footer :title="modal_title" @hidden="CLEAR_FORM_PERSON">

            <ValidationObserver ref="form">
                <validation-provider rules="required" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Person Name</label>
                        <input v-model="formperson.name" type="text" class="form-control" name="categories">
                        <div class="invalid-input">{{ errors[0] }}</div>
                    </div>
                </validation-provider>
                <div class="form-group">
                    <label>Father Name</label>
                    <input v-model="formperson.father" type="text" class="form-control" name="categories">
                </div>
                <div class="form-group">
                    <label>Mother Name</label>
                    <input v-model="formperson.mother" type="text" class="form-control" name="categories">
                </div>
                
                <div class="form-group">
                    <label>Address</label>
                    <input v-model="formperson.address" type="text" class="form-control" name="categories">
                </div>

                <div class="form-group">
                    <label>Status</label>
                    <input v-model="formperson.type" type="text" class="form-control" name="categories">
                </div>

                <validation-provider v-if="!formperson.photo" rules="mimes:image/jpeg,image/png,image/jpg" v-slot="{ errors, validate }">
                    <div class="form-group">
                        <div class="mb-1">
                            <label>Person Photo</label>
                        </div>
                        <div class="btn-up d-flex align-items-center" v-on:click.prevent="$refs.inputImage.click()">
                            <div class="upload"><i class="uil uil-image mr-1"></i> ADD IMAGE</div>
                        </div>
                        <input ref="inputImage" 
                                type="file"
                                class="custom-file-input d-none"
                                id="Thumbnail"
                                v-on:change="onImageUpload"
                                accept="image/jpeg,image/png,image/jpg" 
                                @input="validate" >
    
                        <div class="invalid-input mt-3">{{ errors[0] }}</div>
                    </div>
                </validation-provider>
                
                <div class="form-group" v-if="formperson.photo">   
                    <div class="mb-1">
                        <label>Person Photo</label>
                    </div> 
                    <button v-on:click.prevent="removeImageUpload()" type="button" class="btn-remove-image"><i class="uil uil-times"></i> Delete Photo</button> 
                    <div class="input-group img-sh">
                        <img :src="formperson.photo" class="img-responsive img-prf">
                    </div>
                </div>

                <div class="text-right">
                    <button v-on:click="validationForm(formperson.id)" v-bind:class="loading ? 'btn-progress' : ''" type="button" class="btn btn-new">
                        Save Person
                    </button>
                </div>

            </ValidationObserver>

        </b-modal>
    </div>
</template>

<script>

    import { mapState, mapActions, mapMutations } from 'vuex'
    import {ValidationProvider, ValidationObserver } from "vee-validate";
    import draggable from 'vuedraggable'

    export default{
        data(){
            return{
                drag: false,
                loading:false,
                modal_title : 'Add Person',
                photo_file:'',
            }
        },
        watch:{
            'formperson':function(val){
                if(val.id){
                    this.modal_title = 'Edit Person'
                }else if(!val.id){
                    this.modal_title = "Add Person"
                }
            },
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            draggable,
        },
        computed:{
            ...mapState('EventsControl', {
                detail_event: state => state.detail_event,
                formperson: state => state.formperson
            }),

            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            personsGroup: {
                get() {
                    return this.detail_event.persons
                },
                set(value) {
                    this.SET_POSITION_PERSONS(value)
                    this.updatePositionPerson(value)
                }
            }
        },
        methods:{
            ...mapMutations('EventsControl', ['SET_POSITION_PERSONS','CLEAR_FORM_PERSON','ASSIGN_FORM_PERSON']),
            ...mapActions('EventsControl', ['detailEvents','createPersons','updatePersons','deletePersons','updatePositionPerson']),
            
            onImageUpload: function(event) {
                var input = event.target;

                if (input.files && input.files[0]) {

                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = function(e) {
                        vm.formperson.photo = e.target.result;
                    }
                    reader.readAsDataURL(input.files[0]);
                }
                this.photo_file = input.files[0]
            },
            removeImageUpload:function(){
                this.photo_file = ''
                this.formperson.photo = ''
            },
            validationForm: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var formData = new FormData();
                        formData.append('name', this.formperson.name);
                        if(this.formperson.mother){
                            formData.append('mother', this.formperson.mother);
                        }
                        if(this.formperson.father){
                            formData.append('father', this.formperson.father);
                        }
                        if(this.formperson.address){
                            formData.append('address', this.formperson.address);
                        }
                        if(this.formperson.type){
                            formData.append('type', this.formperson.type);
                        }
                        formData.append('photo', this.photo_file);
                        formData.append('photo_path', this.formperson.photo);
                        
                        if(id){
                            formData.append("_method", "put");

                            this.updatePersons(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Persons')
                                this.detailEvents(this.$route.params.id)
                                this.CLEAR_FORM_PERSON()
                                this.photo_file = ''
                                this.$toast.success('Successfully Update Person')
                            }) 

                        }else{

                            this.createPersons(formData).then(() => {
                                this.loading = false
                                this.$bvModal.hide('modal-Persons')
                                this.detailEvents(this.$route.params.id)
                                this.photo_file = ''
                                this.CLEAR_FORM_PERSON()
                                this.$toast.success('Successfully Added Person')
                            }) 
                        }
                    }
                });
            },
            alertDelete:function(id){
                this.$swal({
                    title: 'Confirmation',
                    icon: 'warning',
                    text: "Are you sure you delete this person data? This action cannot be undone",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel'
                }).then((result) => {
                    if (result.value) {
                        this.deletePersons(id).then(
                            this.$toast.success('Successfully Deleting Person'),
                            this.detailEvents(this.$route.params.id)
                        )
                    }
                })
            },
        }
    }

</script>
